import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { CoreModule } from '../core.module';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastMessage {
	id: number;
	type: ToastType;
	message: string;
}

const DISMISS_AFTER_MS = 5000;

@Injectable({
	providedIn: CoreModule,
})
export class ToastService {
	private _queue = new ReplaySubject<ToastMessage[]>(1);

	private dataStore: ToastMessage[] = [];

	private nextId = 0;

	constructor() { }

	get queue$() {
		return this._queue.asObservable();
	}

	addMessage(message: string | { type?: ToastType; message: string }) {
		const toast: ToastMessage = typeof message === 'string'
			? { id: this.nextId += 1, type: 'info', message }
			: { id: this.nextId += 1, type: message.type ?? 'info', message: message.message };

		this.dataStore.push(toast);
		this._queue.next(this.dataStore);

		setTimeout(() => this.removeMessage(toast.id), DISMISS_AFTER_MS);
	}

	removeMessage(id: number) {
		this.dataStore = this.dataStore.filter((toast) => toast.id !== id);
		this._queue.next(this.dataStore);
	}
}
